// frontend/src/hooks/useSignupStatus.js
// Reads the backend signup gate once per page load and shares the answer
// across every CTA. Defaults to "closed" until the fetch resolves (or if it
// fails), so a backend hiccup can never accidentally advertise open signups.
import { useEffect, useState } from 'react';
import { getSignupStatus } from '../services/auth';

export const CLOSED_STATUS = {
  mode: 'closed',
  open: false,
  inviteCodeRequired: false,
  waitlistUrl: '/waitlist.html'
};

let cached = null;
let inflight = null;

export default function useSignupStatus() {
  const [status, setStatus] = useState(cached);

  useEffect(() => {
    if (cached) return undefined;
    if (!inflight) {
      inflight = getSignupStatus()
        .then((s) => { cached = { ...CLOSED_STATUS, ...s }; return cached; })
        .catch(() => { cached = CLOSED_STATUS; return cached; });
    }
    let live = true;
    inflight.then((s) => { if (live) setStatus(s); });
    return () => { live = false; };
  }, []);

  return status ? { ...status, loading: false } : { ...CLOSED_STATUS, loading: true };
}
